import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardAlarmHistoryContext = createContext(null);
const timeRanges = [
  'Past 7 days',
  'Past 30 days'
];

// declare provider component
const CardAlarmHistoryProvider = ({ children }) => {
  const [alarmHistory, setAlarmHistory] = useState(null);
  const [alarmHistoryTimeRange, setAlarmHistoryTimeRange] = useState(timeRanges[0]);
  const [alarmHistoryLoading, setAlarmHistoryLoading] = useState(null);
  const [alarmHistoryError, setAlarmHistoryError] = useState(null);

  const setTheAlarmHistory = (alarmHistory) => {
    if (logComponent('CardAlarmHistoryContext')) { console.debug('CardAlarmHistoryContext setTheAlarmHistory'); }
    let newAlarmHistory = alarmHistory ? { ...alarmHistory } : null;
    setAlarmHistory(newAlarmHistory);
  }

  const setTheAlarmHistoryTimeRange = (timeRange) => {
    if (logComponent('CardAlarmHistoryContext')) { console.debug('CardAlarmHistoryContext setTheAlarmHistoryTimeRange'); }
    let newTimeRange = timeRange;
    setAlarmHistoryTimeRange(newTimeRange);
  }

  const setTheAlarmHistoryLoading = (alarmHistoryLoading) => {
    if (logComponent('CardAlarmHistoryContext')) { console.debug('CardAlarmHistoryContext setTheAlarmHistoryLoading'); }
    let newAlarmHistoryLoading = alarmHistoryLoading;
    setAlarmHistoryLoading(newAlarmHistoryLoading);
  }

  const setTheAlarmHistoryError = (alarmHistoryError) => {
    if (logComponent('CardAlarmHistoryContext')) { console.debug('CardAlarmHistoryContext setTheAlarmHistoryError'); }
    let newAlarmHistoryError = alarmHistoryError;
    setAlarmHistoryError(newAlarmHistoryError);
  }

  

  const cardState = useMemo(() => ({
    timeRanges,
    alarmHistory,
    alarmHistoryTimeRange,
    alarmHistoryLoading,
    alarmHistoryError,
    setAlarmHistory: setTheAlarmHistory,
    setAlarmHistoryTimeRange: setTheAlarmHistoryTimeRange,
    setAlarmHistoryLoading: setTheAlarmHistoryLoading,
    setAlarmHistoryError: setTheAlarmHistoryError
  }), [
    timeRanges,
    alarmHistory,
    alarmHistoryTimeRange,
    alarmHistoryLoading,
    alarmHistoryError
]);

  return (
    <CardAlarmHistoryContext.Provider value={ cardState }>
      {children}
    </CardAlarmHistoryContext.Provider>
  );
}

// export provider and context
export { CardAlarmHistoryContext, CardAlarmHistoryProvider };